// extracted by mini-css-extract-plugin
export default {"link":"EN-z","disabled":"FN-z"};